module.exports = __webpack_public_path__ + "img/save-alternate.dc596031.svg";